module.exports = __webpack_public_path__ + "static/media/dollar.bb637d5e.svg";